<template>
<div class="acomodar">
    <vSeguiSolicitud/>
</div>
</template>

<script>
import vSeguiSolicitud from "@/components/ModSeleccion/Seguimiento/SegSolicitudPrincipal.vue";
export default {
  name: 'SeguimientoSolicitudP',
  components: {
    vSeguiSolicitud
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style  scoped>
</style>